// import { useHelper } from '@react-three/drei'
import React, {useRef} from 'react'
// import { DirectionalLightHelper } from 'three'

const Lights = () => {

    const ref1 = useRef()
    const ref2 = useRef()
    const ref3 = useRef()

    // useHelper(ref1, DirectionalLightHelper, "red")
    // useHelper(ref2, DirectionalLightHelper, "red")
    // useHelper(ref3, DirectionalLightHelper, "red")
    
    return (
       <>
        <ambientLight intensity = {0.8}/>
        <hemisphereLight intensity={1} color = "#ffffff"  groundColor="#AEAEAE" position= {[0,5, 0]}/>
        {/* <directionalLight 
            ref={ref1} 
            intensity= {0.8} 
            position ={[0, 150, 0]}
        />
        <directionalLight ref={ref2} intensity= {0.8} position ={[420+50, 150, 100]}/>
        <directionalLight ref={ref3} intensity= {0.8} position ={[-420-50, 150, -100]}/> */}
       </>
    )
}

export default Lights
